import { Box, Typography, styled } from '@mui/material'
import { GetRGBA, getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'

export const StyledCategorySection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))

export const CategoryLabel = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const StyledCategoryCard = styled(Box)<{ theme: any }>(({ theme }) => ({
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 4,
  overflow: 'hidden',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
}))

export const SelectionArea = styled(Box)<{ theme: any }>(({ theme }) => ({
  borderBottom: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  padding: theme.spacing(1.5),
}))

export const ChecklistArea = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

export const ChecklistHeader = styled(Box)<{ theme: any }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}))

export const SaveGroupFooter = styled(Box)<{ theme: any }>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(1.5, 2),
  borderTop: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
}))

export const StyledGroupCard = styled(Box)<{ theme: any }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '200px',
  height: '32px',
  padding: theme.spacing(1),
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
  border: `1.5px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    borderColor: getThemeColor(theme, MUIThemeColors.primaryMain),
  },
}))

export const InfoBannerBox = styled(Box)<{ theme: any }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 12px',
  backgroundColor: GetRGBA(getThemeColor(theme, MUIThemeColors.infoLight), 0.3),
  borderRadius: 4,
}))

export const ModeBannerBox = styled(Box)<{ theme: any; mode: 'editing' | 'viewing' }>(({ theme, mode }) => ({
  marginBottom: 10,
  padding: 10,
  backgroundColor:
    mode === 'editing'
      ? GetRGBA(getThemeColor(theme, MUIThemeColors.warningLight), 0.2)
      : GetRGBA(getThemeColor(theme, MUIThemeColors.infoLight), 0.8),
  borderRadius: 4,
}))

export const WhiteAutocompleteBox = styled(Box)<{ theme: any }>(({ theme }) => ({
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 4,
  backgroundColor: ` ${getThemeColor(theme, MUIThemeColors.white)} !important`,
  '& .MuiAutocomplete-listbox': {
    backgroundColor: `${getThemeColor(theme, MUIThemeColors.white)} !important`,
    '& li': {
      backgroundColor: `${getThemeColor(theme, MUIThemeColors.white)} !important`,
    },
    '& .MuiAutocomplete-option': {
      backgroundColor: `${getThemeColor(theme, MUIThemeColors.white)} !important`,
      '&:hover': {
        backgroundColor: `${getThemeColor(theme, MUIThemeColors.secondaryLight)} !important`,
      },
      '&[aria-selected="true"]': {
        backgroundColor: `${getThemeColor(theme, MUIThemeColors.white)} !important`,
      },
      '&.Mui-focused': {
        backgroundColor: `${getThemeColor(theme, MUIThemeColors.secondaryLight)} !important`,
      },
    },
  },
}))

export const GroupCardLabel = styled(Typography)<{ theme: any; isActive: boolean }>(({ theme, isActive }) => ({
  fontWeight: isActive ? 700 : 600,
  color: isActive
    ? getThemeColor(theme, MUIThemeColors.primaryMain)
    : getThemeColor(theme, MUIThemeColors.secondaryMain),
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))
